/* Sfeervuur custom cursor: flame / lighter, plus the picker UI.
   Styles: assets/sf-header.css (section "Custom cursor").
   The cursor lives in a [popover] so it stays visible above open <dialog>s (cart drawer, search). */
(() => {
  'use strict';

  if (window.__sfCursor) return;

  const STORAGE_KEY = 'sf-cursor';
  const MODES = ['default', 'flame', 'lighter'];
  // texts in the visitor's language (snippets/sf-i18n.liquid), Dutch as a fallback
  const I = (window.SF && window.SF.i18n) || {};
  const esc = (s) => String(s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]);
  const COPY = {
    default: { label: esc(I.cursorDefault || 'Standaard'), hint: esc(I.cursorDefaultHint || 'Klassieke muisaanwijzer') },
    flame: { label: esc(I.cursorFlame || 'Vlam'), hint: esc(I.cursorFlameHint || 'Een levendig vuurtje') },
    lighter: { label: esc(I.cursorLighter || 'Aansteker'), hint: esc(I.cursorLighterHint || 'Elegant en goud') },
  };
  const TITLE = esc(I.cursorTitle || 'Kies je cursor');

  const INTERACTIVE =
    'a[href], button, [role="button"], summary, label[for], select, input[type="submit"], input[type="button"], input[type="checkbox"], input[type="radio"], [tabindex]:not([tabindex="-1"])';
  const TEXTY =
    'input:not([type="checkbox"]):not([type="radio"]):not([type="submit"]):not([type="button"]):not([type="range"]):not([type="file"]), textarea, [contenteditable]:not([contenteditable="false"])';

  const mqFine = window.matchMedia('(hover: hover) and (pointer: fine)');
  const mqMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  // ember trail density and click burst size follow the device tier (snippets/sf-perf.liquid)
  const perfP = () => (window.SF && window.SF.perf && window.SF.perf.p) || { trail: 1, burst: 9 };

  let uid = 0;
  const state = { pref: 'default', mode: 'default', x: -100, y: -100, lastX: -100, lean: 0, inside: false, overText: false, force: false, overInteractive: false };
  let fx = null;
  let cur = null;
  let leanEl = null;
  let innerEl = null;
  let raf = 0;
  let emberX = 0;
  let emberY = 0;
  let observing = false;

  /* ---------- SVG art ---------- */

  function flameSVG(w = 26, h = 36) {
    const id = `sfF${++uid}`;
    return `<svg width="${w}" height="${h}" viewBox="0 0 32 44" aria-hidden="true" focusable="false">
      <defs>
        <linearGradient id="${id}a" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0" stop-color="#FFEEC3"/><stop offset=".32" stop-color="#F3C173"/>
          <stop offset=".68" stop-color="#F8A22F"/><stop offset="1" stop-color="#E8621A"/>
        </linearGradient>
        <linearGradient id="${id}b" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0" stop-color="#FFFFFF"/><stop offset="1" stop-color="#FFD98A"/>
        </linearGradient>
      </defs>
      <g class="sf-flame__outer"><path fill="url(#${id}a)" stroke="rgba(70,28,0,.5)" stroke-width=".7"
        d="M16 1.5C17.4 8.5 27 14 27 27.5 27 36.6 22.2 42.5 16 42.5S5 36.6 5 27.5C5 21.5 8 17.5 10.6 13.2 11 16.8 12.4 18.6 14.2 18.9 12.8 12.6 13.6 6.2 16 1.5Z"/></g>
      <g class="sf-flame__inner"><path fill="url(#${id}b)" opacity=".95"
        d="M16 20C18.8 24.8 22 27.6 21.4 32.6 20.9 37.3 18.6 40 16 40S11 37.3 11 33.2C11 29.2 14 26.2 16 20Z"/></g>
    </svg>`;
  }

  function lighterSVG(open) {
    const id = `sfL${++uid}`;
    return `<svg class="sf-lighter" data-state="${open ? 'open' : ''}" width="44" height="49" viewBox="0 0 68 76" aria-hidden="true" focusable="false">
      <defs>
        <linearGradient id="${id}g" x1="0" y1="0" x2="1" y2="0">
          <stop offset="0" stop-color="#805020"/><stop offset=".22" stop-color="#DBA660"/><stop offset=".42" stop-color="#FFEEC3"/>
          <stop offset=".62" stop-color="#DBA660"/><stop offset="1" stop-color="#6A3F16"/>
        </linearGradient>
        <linearGradient id="${id}s" x1="0" y1="0" x2="1" y2="0">
          <stop offset="0" stop-color="#8F7A52"/><stop offset=".5" stop-color="#EFE3C4"/><stop offset="1" stop-color="#8F7A52"/>
        </linearGradient>
        <linearGradient id="${id}f" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0" stop-color="#FFEEC3"/><stop offset=".45" stop-color="#F8A22F"/><stop offset="1" stop-color="#E8621A"/>
        </linearGradient>
      </defs>
      <rect x="10" y="40" width="26" height="34" rx="3.5" fill="url(#${id}g)" stroke="rgba(60,30,0,.55)" stroke-width=".6"/>
      <path d="M13 48h20M13 52h20" stroke="rgba(60,30,0,.35)" stroke-width=".7" fill="none"/>
      <rect x="10" y="40" width="26" height="3" fill="rgba(60,30,0,.28)"/>
      <rect x="13" y="29" width="20" height="12" rx="1.5" fill="url(#${id}s)" stroke="rgba(40,25,5,.6)" stroke-width=".5"/>
      <g fill="rgba(30,18,4,.65)"><ellipse cx="17.5" cy="34.500" rx="1.300" ry="1.800"/><ellipse cx="23" cy="34.500" rx="1.300" ry="1.800"/><ellipse cx="28.500" cy="34.500" rx="1.300" ry="1.800"/></g>
      <g class="sf-lighter__flame"><g class="sf-lighter__flame-shape">
        <path fill="url(#${id}f)" d="M23 4C24.600 10.500 30 14 30 21c0 5-3 8-7 8s-7-3-7-8c0-4 3-7 4-11 1 2 2 3 3 3.200C21.400 12 21.500 8 23 4Z"/>
        <path fill="#FFF6DC" opacity=".9" d="M23 17c1.800 2.600 3.400 4.200 3.400 7 0 2.400-1.400 4-3.400 4s-3.400-1.600-3.400-4c0-2.600 1.800-4.400 3.400-7Z"/>
      </g></g>
      <g class="sf-lighter__lid">
        <rect x="10" y="24" width="26" height="17" rx="3.5" fill="url(#${id}g)" stroke="rgba(60,30,0,.55)" stroke-width=".6"/>
        <path d="M13 31h20" stroke="rgba(60,30,0,.3)" stroke-width=".7"/>
        <rect x="14" y="26" width="18" height="2" rx="1" fill="rgba(255,238,195,.5)"/>
      </g>
    </svg>`;
  }

  function arrowSVG() {
    return `<svg width="22" height="28" viewBox="0 0 22 28" aria-hidden="true" focusable="false">
      <path d="M3 2v20l5.500-5 3.500 8 3-1.300-3.500-7.700H19Z" fill="#F4ECDD" stroke="#050505" stroke-width="1.200" stroke-linejoin="round"/>
    </svg>`;
  }

  const ART = { default: () => arrowSVG(), flame: () => flameSVG(26, 36), lighter: () => lighterSVG(false) };
  const PREVIEW = { default: () => arrowSVG(), flame: () => flameSVG(24, 33), lighter: () => lighterSVG(true) };

  /* ---------- storage ---------- */

  function readPref() {
    try {
      const v = window.localStorage.getItem(STORAGE_KEY);
      return MODES.includes(v) ? v : null;
    } catch (e) {
      return null;
    }
  }

  function writePref(v) {
    try {
      window.localStorage.setItem(STORAGE_KEY, v);
    } catch (e) {
      /* private mode etc. */
    }
  }

  /* ---------- DOM ---------- */

  function ensureFx() {
    if (fx) return;

    fx = document.createElement('div');
    fx.className = 'sf-fx';
    fx.setAttribute('popover', 'manual');
    fx.setAttribute('aria-hidden', 'true');

    cur = document.createElement('div');
    cur.className = 'sf-cur';
    cur.dataset.visible = 'false';

    leanEl = document.createElement('div');
    leanEl.className = 'sf-cur__lean';

    innerEl = document.createElement('div');
    innerEl.className = 'sf-cur__inner';

    leanEl.appendChild(innerEl);
    cur.appendChild(leanEl);
    fx.appendChild(cur);
    document.body.appendChild(fx);
  }

  function showFx() {
    if (!fx) return;
    try {
      if (typeof fx.showPopover === 'function' && !fx.matches(':popover-open')) fx.showPopover();
    } catch (e) {
      fx.style.zIndex = '2147483647';
    }
  }

  function hideFx() {
    if (!fx) return;
    try {
      if (typeof fx.hidePopover === 'function' && fx.matches(':popover-open')) fx.hidePopover();
    } catch (e) {
      /* ignore */
    }
  }

  function raiseFx() {
    if (!fx) return;
    try {
      if (fx.matches(':popover-open')) {
        fx.hidePopover();
        fx.showPopover();
      }
    } catch (e) {
      /* ignore */
    }
  }

  function syncVisible() {
    if (!cur) return;
    cur.dataset.visible = String(state.mode !== 'default' && state.inside && !state.overText);
  }

  /* ---------- effects ---------- */

  function spawn(className, vars, life) {
    if (!fx || fx.childElementCount > 70 * Math.max(1, perfP().trail)) return;
    const el = document.createElement('span');
    el.className = className;
    for (const key in vars) el.style.setProperty(key, vars[key]);
    el.addEventListener('animationend', () => el.remove(), { once: true });
    fx.appendChild(el);
    if (life) window.setTimeout(() => el.remove(), life);
  }

  function ember(x, y) {
    spawn(
      'sf-ember',
      {
        '--x': `${(x + (Math.random() * 10 - 5)).toFixed(1)}px`,
        '--y': `${(y + 16 + Math.random() * 6).toFixed(1)}px`,
        '--dx': `${(Math.random() * 26 - 13).toFixed(1)}px`,
        '--s': `${(2 + Math.random() * 3).toFixed(1)}px`,
      },
      1400
    );
  }

  function burst(x, y) {
    const count = perfP().burst;
    for (let i = 0; i < count; i++) {
      const angle = (Math.PI * 2 * i) / count + Math.random() * 0.5;
      const dist = 16 + Math.random() * 26;
      spawn(
        'sf-spark',
        {
          '--x': `${x.toFixed(1)}px`,
          '--y': `${y.toFixed(1)}px`,
          '--dx': `${(Math.cos(angle) * dist).toFixed(1)}px`,
          '--dy': `${(Math.sin(angle) * dist).toFixed(1)}px`,
        },
        1000
      );
    }
  }

  /* ---------- frame loop ---------- */

  function frame() {
    raf = 0;
    if (!cur) return;

    cur.style.transform = `translate3d(${state.x}px, ${state.y}px, 0)`;

    if (state.mode === 'flame' && !mqMotion.matches) {
      const target = Math.max(-16, Math.min(16, (state.x - state.lastX) * 0.8));
      state.lean += (target - state.lean) * 0.4;
      state.lastX = state.x;
      leanEl.style.setProperty('--lean', `${state.lean.toFixed(2)}deg`);
      if (Math.abs(state.lean) > 0.08 || Math.abs(target) > 0.08) raf = window.requestAnimationFrame(frame);
    }
  }

  function schedule() {
    if (!raf) raf = window.requestAnimationFrame(frame);
  }

  /* ---------- pointer wiring (once) ---------- */

  function onMove(e) {
    if (e.pointerType === 'touch') return;
    state.x = e.clientX;
    state.y = e.clientY;
    if (!state.inside) {
      state.inside = true;
      state.lastX = state.x;
      syncVisible();
    }
    const trail = perfP().trail;
    if (state.mode === 'flame' && !mqMotion.matches && trail > 0 && Math.hypot(state.x - emberX, state.y - emberY) > 24 / trail) {
      emberX = state.x;
      emberY = state.y;
      ember(state.x, state.y);
    }
    schedule();
  }

  function onOver(e) {
    if (!cur || !(e.target instanceof Element)) return;
    const texty = !!e.target.closest(TEXTY);
    if (texty !== state.overText) {
      state.overText = texty;
      syncVisible();
    }
    state.overInteractive = !texty && !!e.target.closest(INTERACTIVE);
    cur.dataset.hover = String(state.force || state.overInteractive);
  }

  function onDown(e) {
    if (!cur || e.pointerType === 'touch' || state.mode === 'default') return;
    cur.dataset.down = 'true';
    if (!mqMotion.matches) burst(e.clientX, e.clientY);
  }

  function onUp() {
    if (cur) cur.dataset.down = 'false';
  }

  function onLeave() {
    state.inside = false;
    syncVisible();
  }

  function wire() {
    if (observing) return;
    observing = true;

    document.addEventListener('pointermove', onMove, { passive: true });
    document.addEventListener('pointerover', onOver, true);
    document.addEventListener('pointerdown', onDown, true);
    document.addEventListener('pointerup', onUp, true);
    document.addEventListener('pointercancel', onUp, true);
    document.documentElement.addEventListener('mouseleave', onLeave);

    // keep the cursor above modal <dialog>s that open later in the top layer
    new MutationObserver((records) => {
      for (const r of records) {
        if (r.target instanceof HTMLDialogElement && r.target.open) {
          raiseFx();
          return;
        }
      }
    }).observe(document.documentElement, { subtree: true, attributes: true, attributeFilter: ['open'] });
  }

  /* ---------- public: set mode ---------- */

  function apply(mode, persist) {
    if (!MODES.includes(mode)) mode = 'default';
    if (persist) {
      state.pref = mode;
      writePref(mode);
    }

    const effective = mqFine.matches ? mode : 'default';
    state.mode = effective;
    const html = document.documentElement;
    html.dataset.sfCursor = effective;

    if (effective === 'default') {
      html.classList.remove('sf-cursor-on');
      hideFx();
      if (cur) cur.dataset.visible = 'false';
    } else {
      ensureFx();
      wire();
      innerEl.innerHTML = ART[effective]();
      cur.className = `sf-cur sf-cur--${effective}`;
      cur.dataset.hover = 'false';
      cur.dataset.down = 'false';
      leanEl.style.setProperty('--lean', '0deg');
      html.classList.add('sf-cursor-on');
      showFx();
      syncVisible();
      schedule();
    }

    document.dispatchEvent(new CustomEvent('sf-cursor-change', { detail: { mode: state.pref } }));
  }

  /* ---------- picker UI ---------- */

  const GLYPH = `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.1" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">
    <g class="sf-flame-glyph">
      <path d="M12 2.500c.8 4 6 6.500 6 12.500 0 4.100-2.700 6.500-6 6.500S6 19.100 6 15c0-3 1.700-4.900 3-7 .3 1.900 1 2.800 2 2.900C10.200 7.400 10.500 4.800 12 2.500Z"/>
      <path d="M12 13c1.500 2 2.600 3.100 2.500 5-.1 1.700-1.200 2.500-2.500 2.500s-2.500-.9-2.500-2.500c0-1.600 1.500-2.800 2.500-5Z"/>
    </g></svg>`;
  const CHECK = `<svg class="sf-cursor-option__check" viewBox="0 0 14 14" fill="none" stroke="currentColor" stroke-width="1.400" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m2.500 7.500 3 3 6-7"/></svg>`;

  let pickerCount = 0;

  function mountPicker(host) {
    if (!host || host.dataset.mounted === 'true') return;
    if (!mqFine.matches) return; // touch devices have no cursor to pick

    host.dataset.mounted = 'true';
    host.hidden = false;

    const menuId = `sf-cursor-menu-${++pickerCount}`;
    host.innerHTML = `
      <button type="button" class="sf-icon-btn" aria-haspopup="true" aria-expanded="false" aria-controls="${menuId}" aria-label="${TITLE}">${GLYPH}</button>
      <div class="sf-cursor-menu" id="${menuId}" data-open="false" role="radiogroup" aria-label="${TITLE}" inert>
        <p class="sf-cursor-menu__title">${TITLE}</p>
        ${MODES.map(
          (m) => `
          <button type="button" class="sf-cursor-option" role="radio" aria-checked="false" data-mode="${m}">
            <span class="sf-cursor-option__preview">${PREVIEW[m]()}</span>
            <span class="sf-cursor-option__label">${COPY[m].label}<span class="sf-cursor-option__hint">${COPY[m].hint}</span></span>
            ${CHECK}
          </button>`
        ).join('')}
      </div>`;

    const btn = host.querySelector('.sf-icon-btn');
    const menu = host.querySelector('.sf-cursor-menu');
    const options = [...menu.querySelectorAll('.sf-cursor-option')];

    const sync = () => options.forEach((o) => o.setAttribute('aria-checked', String(o.dataset.mode === state.pref)));
    const setOpen = (open) => {
      menu.dataset.open = String(open);
      menu.inert = !open;
      btn.setAttribute('aria-expanded', String(open));
    };

    sync();
    document.addEventListener('sf-cursor-change', sync);

    btn.addEventListener('click', () => {
      const open = menu.dataset.open !== 'true';
      setOpen(open);
      if (open) (options.find((o) => o.getAttribute('aria-checked') === 'true') || options[0]).focus({ preventScroll: true });
    });

    options.forEach((o) =>
      o.addEventListener('click', () => {
        apply(o.dataset.mode, true);
        // let the visitor see the new cursor before the menu tucks away
        window.setTimeout(() => {
          if (menu.dataset.open === 'true') {
            setOpen(false);
            btn.focus({ preventScroll: true });
          }
        }, 700);
      })
    );

    menu.addEventListener('keydown', (e) => {
      const i = options.indexOf(document.activeElement);
      if (e.key === 'ArrowDown' || e.key === 'ArrowRight') {
        e.preventDefault();
        options[(i + 1) % options.length].focus();
      } else if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') {
        e.preventDefault();
        options[(i - 1 + options.length) % options.length].focus();
      }
    });

    host.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && menu.dataset.open === 'true') {
        setOpen(false);
        btn.focus();
      }
    });

    document.addEventListener('pointerdown', (e) => {
      if (menu.dataset.open === 'true' && !host.contains(e.target)) setOpen(false);
    });
    host.addEventListener('focusout', (e) => {
      if (menu.dataset.open === 'true' && !host.contains(e.relatedTarget)) setOpen(false);
    });
  }

  /* ---------- init ---------- */

  function init() {
    const stored = readPref();
    const header = document.querySelector('sf-header');
    const fallback = (header && header.dataset.defaultCursor) || 'flame';
    state.pref = stored || (MODES.includes(fallback) ? fallback : 'flame');
    apply(state.pref, false);

    const onChange = () => apply(state.pref, false);
    if (mqFine.addEventListener) mqFine.addEventListener('change', onChange);
  }

  // other components (hero fireplace) can light the cursor up while it is "near a flame"
  function force(on) {
    state.force = !!on;
    if (cur && state.mode !== 'default') cur.dataset.hover = String(state.force || state.overInteractive);
  }

  window.__sfCursor = {
    force,
    set: (mode) => apply(mode, true),
    get: () => state.pref,
    mountPicker,
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
